import useStatementHistoryConnectorId from 'modules/common/hooks/useStatementHistoryConnectorId';
import useQuilttSessionToken from 'services/quiltt/queries/useQuilttSessionToken';

/**
 * The Quiltt connector Accounting Setup should use. Bank Settings applies the same override (see
 * useStatementHistoryConnectorId). Ids come from the session token to stay env-correct and keep
 * production connector ids out of the bundle.
 *
 * Every Accounting Setup surface must read the connector from here. If the step and the
 * visibility/eligibility gates disagree, one connector's resolvability verdict auto-skips the step while
 * the other is the one that would have opened.
 */
export default function useAccountingSetupConnectorId(): string | undefined {
    const { data: sessionToken } = useQuilttSessionToken();

    return useStatementHistoryConnectorId() ?? sessionToken?.connectorId;
}
